export type RegionChartSingleKneeProps = {
  examMLResultRightKnee: any;
  examMLResultLeftKnee: any;
  title: string;
};

export type RegionChartProps = {
  examMLResultDoubleKnee?: any;
  title: string;
};

export type ExamType = {
  outcomeScore: number;
  createdAt: string;
};

export const enum FilterType {
  PATIENT_FILTER,
  ATHLETE_FILTER,
}
